<template>
  <el-dialog title="单项权益" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%" style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <div class="grid-height">

          <div class="table_main" style="height: 400px!important;">
            <vxe-grid ref="table-m1" :radio-config="{ highlight: true }"
                      @cell-click="cellClickEvent"
                      @radio-change="radioChangeEvent"
                      show-overflow height="390" :row-config="{ isHover: true }"
                      v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
                      @custom="$vxeTableUtil.customHandle">

              <template #form>

                <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
                          :data="formData" @submit="searchEvent" @reset="searchEvent">

                  <vxe-form-item title="权益编码:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.designCode" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="权益名称:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.rightsName" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="权益分类:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.rightsCategory" clearable style="width:9vw!important ;">
                        <el-option label="默认" :value="0" />
                        <el-option label="资产条码权益" :value="1" />
                        <el-option label="资产型号权益" :value="2" />
                        <el-option label="用户权益" :value="3" />
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="是否支持自助报单:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.isSelfService" clearable style="width:9vw!important ;">
                        <el-option :value="0" label="否"></el-option>
                        <el-option :value="1" label="是"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>

                </vxe-form>
                <div class="clearfix screen-btns">
                  <div class="fr" style="display: inline-block;
    float: right;
    margin-top: -39px;">
                    <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                                @click="searchEvent">搜索</vxe-button>
                  </div>
                </div>
              </template>
              <template #pager>
                <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
              </template>
            </vxe-grid>
          </div>
        </div>
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="commitRow" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
  </el-dialog>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import { initVxeTable } from '@/const/crud/admin/table'

import { fetchTree } from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'param','excludeId'],
  mixins: [selectDialogMixins],
  components: { pager },

  created() {
    // this.initSetting();
    if (this.excludeId) {
      console.log("this.excludeId",this.excludeId)
      this.formData.excludeId = [this.excludeId]
      console.log("this.formData.excludeId",this.formData.excludeId)
    }
    // if (this.siteFloorLevel) {
    //   this.formData.siteFloorLevel = this.siteFloorLevel
    // }
    // if (this.orgId) {
    //   this.formData.orgId = this.orgId
    // }
    // if (this.orgIdPath) {
    //   this.formData.orgIdPath = this.orgIdPath
    // }

    // if (this.param) {
    //   if (this.param.orgIdPath) {
    //     this.formData.orgIdPath = this.param.orgIdPath
    //   }
    // }
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },

  data() {
    return {
      total: 0,
      filterText: '',
      data: [],
      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        isProduct:1,
        size: 0,
        current: 1,
        searchCount: false,
        userName: "",
        excludeId: [],  // 排除id
        // stat: 5,
        // siteFloorLevel: null,  // 网点层级,
        // orgId: null, // 机构id
        // orgIdPath: null,
        // excludeWarehouseId: null
      },
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      searchSiteName: '',
      selectedRow: {
        id: '',
      }
    };
  },


  methods: {
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    cellClickEvent (e) {
      console.log(e.row.id,'单元格点击事件')
    },

    radioChangeEvent ({ row }) {
      this.selectedRow = {
        id: row.id,
        designCode: row.designCode,
        rightsName: row.rightsName,
        rightsCategory: row.rightsCategory,
        rightsType: row.rightsType,
        unit: row.unit,
        effectType: row.effectType,
        effectPeriod: row.effectPeriod,
        feeType: row.feeType,
        isLimit: row.isLimit,
        settlePrice: row.settlePrice,
        limitAmount: row.limitAmount,
        isShow: row.isShow,
      }
    },


    commitRow() {
      if (this.selectedRow.id !== '') {
        this.$emit('commit', this.selectedRow)
        this.dialogClose()
      } else {
        this.$message.warning('请先选中数据')
      }
    },


    // 分页功能
    changeTablePage(page, flag) {
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.initTableList();
    },

    // 搜索
    searchEvent() {
      this.requestParam = this.formData
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {
      this.searchSiteName = ''
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
      this.reloadTree()
    },

    // 新增
    // openEditDialog(id) {
    //   this.dataId = !id || typeof id == 'object' ? 0 : id;
    //   this.activeName = 'first';
    //   this.$openEditView('showEdit');
    // },

    initTableList() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: api.basRightsDesign.getListPageUrl,
        param: this.formData,
        method: 'post',
        columns: [
          {type: "radio", width: 40, title: '', resizable: false, fixed: 'left'},
          {
            title: '权益编码', field: 'designCode', width: 150, slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span style="color: blue"
                        onClick={($event) => this.showInfo(row, $event)}>{row.designCode}</span>
                ]
              }
            }
          },
          {title: '权益名称', field: 'rightsName', width: 150,},
          {
            title: '权益分类', field: 'rightsCategory', width: 150, slots: {
              default: ({ row }) => {
                if (row.rightsCategory == 0) {
                  return [
                    <div class="txt-status disable">
                      <span>默认</span>
                    </div>
                  ];
                } else if (row.rightsCategory == 1) {
                  return [
                    <div class="txt-status">
                      <span>资产条码权益</span>
                    </div>
                  ];
                }else if (row.rightsCategory == 2) {
                  return [
                    <div class="txt-status disable">
                      <span>资产型号权益</span>
                    </div>
                  ];
                } else if (row.rightsCategory == 3) {
                  return [
                    <div class="txt-status">
                      <span>用户权益</span>
                    </div>
                  ];
                }
              }
            }
          },

          {
            title: '权益类型', field: 'rightsType', width: 150, slots: {
              default: ({ row }) => {
                if (row.rightsType == 1) {
                  return [
                    <div class="txt-status disable">
                      <span>保修卡</span>
                    </div>
                  ];
                } else if (row.rightsType == 2) {
                  return [
                    <div class="txt-status">
                      <span>延保卡</span>
                    </div>
                  ];
                }else if (row.rightsType == 3) {
                  return [
                    <div class="txt-status disable">
                      <span>保养卡</span>
                    </div>
                  ];
                } else if (row.rightsType == 4) {
                  return [
                    <div class="txt-status">
                      <span>清洗卡</span>
                    </div>
                  ];
                } else if (row.rightsType == 9) {
                  return [
                    <div class="txt-status">
                      <span>其他</span>
                    </div>
                  ];
                }
              }
            }
          },
          {
            title: '是否支持自助报单', field: 'isSelfService', width: 150, slots: {
              default: ({ row }) => {
                if (row.isSelfService == 0) {
                  return [
                    <div class="txt-status disable">
                      <span>否</span>
                    </div>
                  ];
                } else if (row.isSelfService == 1) {
                  return [
                    <div class="txt-status">
                      <span>是</span>
                    </div>
                  ];
                }
              }
            }
          },
          {
            title: '是否工单显示', field: 'isShow', width: 150, slots: {
              default: ({ row }) => {
                if (row.isShow == 0) {
                  return [
                    <div class="txt-status disable">
                      <span>否</span>
                    </div>
                  ];
                } else if (row.isShow == 1) {
                  return [
                    <div class="txt-status">
                      <span>是</span>
                    </div>
                  ];
                }
              }
            }
          },
          { title: '权益数值', field: 'rightsValue', width: 150, },
          {
            title: '单位', field: 'unit', width: 150, slots: {
              default: ({ row }) => {
                if (row.unit == 1) {
                  return [
                    <div class="txt-status disable">
                      <span>月</span>
                    </div>
                  ];
                } else if (row.unit == 2) {
                  return [
                    <div class="txt-status">
                      <span>次</span>
                    </div>
                  ];
                }
              }
            }
          },
          {
            title: '生效日类型', field: 'effectType', width: 150, slots: {
              default: ({ row }) => {
                if (row.effectType == 1) {
                  return [
                    <div class="txt-status disable">
                      <span>激活日</span>
                    </div>
                  ];
                } else if (row.effectType == 2) {
                  return [
                    <div class="txt-status">
                      <span>安装日</span>
                    </div>
                  ];
                }
              }
            }
          },
          {
            title: '额度类型', field: 'isLimit', width: 150, slots: {
              default: ({ row }) => {
                if (row.isLimit == 1) {
                  return [
                    <div class="txt-status disable">
                      <span>不限额</span>
                    </div>
                  ];
                } else if (row.isLimit == 2) {
                  return [
                    <div class="txt-status">
                      <span>限额</span>
                    </div>
                  ];
                }
              }
            }
          },
          { title: '最高限额', field: 'limitAmount', width: 150, },
          { title: '销售价格', field: 'salePrice', width: 150, },
          { title: '结算价', field: 'settlePrice', width: 150, },
          { title: '创建人', field: 'createBy', width: 150, },
          { title: '创建时间', field: 'createTime', width: 150, },
        ]
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed()
    },

    // initTableList() {
    //   let tableOption = {
    //     vue: this,
    //     tableRef: 'table-m1',
    //     tableName: 'basic_fault_code_list-m1',
    //     path: api.slPriceLable.getPageDataUrl,
    //     param: this.formData,
    //     method: 'post',
    //     columns:
    //
    //     [
    //     { type: 'radio', title: '', width: 60, resizable: false, fixed: 'left' },
    //     { title: '价格标签', field: 'lableName', width: 150, },
    //     {
    //       title: '是否使用', field: 'usable', width: 150, slots: {
    //         default: ({ row }) => {
    //           if (row.usable == 0) {
    //             return [
    //               <div class="txt-status disable">
    //                 <span>否</span>
    //               </div>
    //             ];
    //           } else if (row.usable == 1) {
    //             return [
    //               <div class="txt-status">
    //                 <span>是</span>
    //               </div>
    //             ];
    //           }
    //         }
    //       }
    //     },
    //     { title: '保障金额', field: 'maxAmount', width: 150,},
    //     { field: 'createTime', title: '创建时间', width: 150 },
    //     { title: '创建人', field: 'createBy', width: 150, },
    //
    //     // {
    //     //   width: 60, fixed: 'right', title: '操作', sortable: false, slots: {
    //     //     default: ({ row }) => {
    //     //       return [
    //     //         <div>
    //     //           <a
    //     //             href="javascript:void(0);"
    //     //             class="a-link"
    //     //             onclick={() => {
    //     //               this.openEditDialog(row.id);
    //     //             }}
    //     //           >
    //     //             <el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
    //     //               <i class="el-icon-edit" />
    //     //             </el-tooltip>
    //     //           </a>
    //     //         </div>
    //     //       ];
    //     //     }
    //     //   }
    //     // }
    //   ],
    //   };
    //   this.vxeOption = initVxeTable(tableOption);
    //   this.flushed()
    // },


  }
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 400px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: 100%;
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}




::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon {
  font-size: 14px !important;
}



::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}
</style>
